<div>
    <app-form-group>
        <app-select [attr.data-test-id]="'university-' + uniqueId" label="Välj det lärosäte där du tagit din examen" [control]="code">
            <option *ngFor="let university of universities" [value]="university.code">
                {{university.name}}
            </option>
        </app-select>
    </app-form-group>
    <app-form-group>
        <app-select [attr.data-test-id]="'year-' + uniqueId" label="Välj examensår" [control]="year">
            <option *ngFor="let year of years" [value]="year">{{year}}</option>
        </app-select>
    </app-form-group>
</div>